/**
 * 数值配置
 * 配置各种策划提供的数值
 *
 */
export default {
  registrationBonus: 600,
  depositDefaultOptions: [
    { get: 10000, price: 10000 },
    { get: 30000, price: 30000 },
    { get: 50000, price: 50000 },
    { get: 102000, hot: 0, more: 2, price: 100000 },
    { get: 204000, hot: 0, more: 2, price: 200000 },
    { get: 307500, hot: 0, more: 2.5, price: 300000 },
    { get: 515000, hot: 0, more: 3, price: 500000 },
    { get: 828000, hot: 0, more: 3.5, price: 800000 },
    { get: 1040000, hot: 0, more: 4, price: 1000000 },
    { get: 2080000, hot: 0, more: 4, price: 2000000 },
    { get: 3150000, hot: 0, more: 4.5, price: 3000000 },
    { get: 5250000, hot: 0, more: 5, price: 5000000 },
  ],
  //首充金额
  // firstRechargeAmount: 5000,
  //第二档首充活动
  firstRechargeAmount2: 3000000,
  //第三档首充活动
  firstRechargeAmount3: 6000000,
  //限时活动
  limitDiscounts: 30000000,
  firstRechargedWithdrawNeedBets: 6000000,
  depositActivityAmount: 9000000,
  depositActivityMore: 20,
  defaultDepositGot: 30000,
  defaultDepositPrice: 29700,
  //最低充值金额
  minDepositAmount: 1500000,
  maxDepositAmount: 600000000,
  withdrawFeePercent: 0,
  minWithdrawAmount: 9000000,
  maxWithdrawAmount: 360000000,
  maxWithdrawDailyAmount: 1800000000,
  //砍一刀金额，大厅的一个转盘
  inviteWheel: {
    targetAmount: 18000000,
  },
  luckyDraw: {
    marqueeAmoundList: [36000, 144000, 360000, 90000, 9000, 36000, 14400, 180000, 144000, 90000, 900000, 180000, 144000, 18000, 90000, 9000, 1440000, 14400, 18000, 3600],
  },
  addHomeScreenRewardFrom: 600,
  addHomeScreenRewardTo: 90000,
  gasBurnRatio: 0,
  betGasRatio: 1,
  depositGasRatio: 0,
  useWithdrawLevel: 0,
};
